
<template>
  <div :class="hidedata?'r-d r-dr':'r-d'">
    <div v-loading="loadingRight" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="l-t l-t-w">
        <h3 v-html="itemData.highSpeedName"></h3>
        <span>途径城市数据</span>
        <div>
          <img width="16" src="../../../assets/images/day.png" />日运营车次
          <img class="img" width="16" src="../../../assets/images/iol.png" />日均加油站停靠
        </div>
      </div>
      <div class="l-cont l-cont-t">
        <ul class="ranimate">
          <div
            v-for="(i,k) in itemData.listData"
            :key="k"
            :class="k==activeIndex?'a':''"
            @click="clickData(i.cityName,i.cityCode)"
            @mouseover="overFun(k)"
            @mouseout="outFun"
          >
            <div class="rt">
              <div class="rt-l">{{i.cityName}}</div>
              <div class="rt-r">
                <div>
                  <img width="16" src="../../../assets/images/day.png" />
                  <span class="font-o">{{i.operationsRange}}</span>
                </div>
                <div>
                  <img width="16" src="../../../assets/images/iol.png" />
                  <span class="font-o">{{i.gasStationRange}}</span>
                </div>
              </div>
            </div>
            <div class="rb">
              <div>
                {{i.logisticsPark}}
                <div>
                  物流园停靠
                  <br />（日均）
                </div>
              </div>
              <div>
                {{i.density}}
                <div>城市加油站密度 <br />（座/百公里）</div>
              </div>
              <div>
                {{i.lugNumber}}
                <div>
                  LNG车次
                  <br />（日均）
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>
      <div class="more">
        <div class="m" @click="moreCity">more</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeIndex: '-1',
      loading: true
    }
  },
  props: {
    loadingRight: Boolean,
    itemData: Object,
    hidedata: Boolean,
    clickId: Number
  },

  watch: {},
  created() {},
  mounted() {},
  methods: {
    getData(k) {
      this.btnIndex = k
    },
    // 获取详情
    clickData(cityName, cityCode) {
      // this.$parent.showMapDetails=true
      // console.log(cityCode)
      // this.$emit("getMapDetails",cityName,cityCode)
      this.$router.push({
        path: '/roadOperation/hotCities?',
        query: { id: this.clickId, cityName: cityName, cityCode: cityCode,isHotCity: false}
      })

      // axios.getRoadDetails(id, '').then(e => {
      //   _this.objData = e.data
      //   _this.showRightData = true
      //   _this.loadingRight = false
      // })
      // console.log(code)
    },
    // 鼠标放上去事件
    overFun(i) {
      this.activeIndex = i
    },
    outFun() {
      this.activeIndex = -1
    },
    moreCity() {
      this.$parent.showwayCity = true
      // this.$router.push({
      //   path: '/roadOperation/wayCity?',
      //   query: { id: this.clickId }
      // })
    },
    // 监听滚动
    setTimer() {
      if (this.itemData.listData  && document.querySelector('.l-cont-t')!=null) {
        var h = document.querySelector('.ranimate').offsetHeight
        var t = document.querySelector('.l-cont-t').scrollTop
        this.switchTime = setInterval(function() {
          if (h - t <= 0) {
            t = 0
          } else {
            t = t + 0.1
          }
          document.querySelector('.l-cont-t').scrollTop = t
        }, 1)
      }
    }
  }
}
</script>
<style scoped>
.m {
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  opacity: 0.6;
  width: 98%;
  margin-left: 1%;
  background-image: linear-gradient(-90deg, #2daaff 2%, #5a74fc 98%);
  border-radius: 2px;
}

.m:hover {
  opacity: 1;
  cursor: pointer;
}

.more {
  width: 100%;
  position: absolute;
  bottom: 0px;
  height: 30px;
  padding-top: 10px;
  z-index: 900;
  background: #2b304c;
}
</style>